// src/components/Sidebar.jsx
import React, { useState } from 'react';
import {
  LayoutDashboard, BookOpen, PlusCircle, AlertTriangle,
  Settings, TrendingUp, ChevronRight, BarChart2,
  Menu, X, Calendar, Calculator, ArrowLeftRight, FlaskConical
} from 'lucide-react';
import ODFLogo from './ODFLogo';
import { t } from '../lib/i18n';

export default function Sidebar({ active, onChange, lang = 'en' }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const NAV = [
    { id: 'dashboard',     label: t(lang,'nav_dashboard'),  icon: LayoutDashboard },
    { id: 'journal',       label: t(lang,'nav_journal'),    icon: BookOpen },
    { id: 'calendar',      label: t(lang,'nav_calendar'),   icon: Calendar },
    { id: 'new-trade',     label: t(lang,'nav_newTrade'),   icon: PlusCircle },
    { id: 'discipline',    label: t(lang,'nav_discipline'), icon: AlertTriangle },
    { id: 'calculator',    label: t(lang,'nav_calculator'), icon: Calculator },
    { id: 'markets',       label: t(lang,'nav_markets'),    icon: BarChart2 },
    { id: 'risk',          label: t(lang,'nav_risk'),       icon: TrendingUp },
    { id: 'import-export', label: t(lang,'nav_import'),     icon: ArrowLeftRight },
    { id: 'lab',           label: t(lang,'nav_lab'),        icon: FlaskConical },
    { id: 'settings',      label: t(lang,'nav_settings'),   icon: Settings },
  ];
  const handleNav = (id) => { onChange(id); setMobileOpen(false); };

  const sidebarContent = (
    <>
      <div style={{ padding: '0 4px', marginBottom: 4, cursor: 'pointer' }} onClick={() => window.dispatchEvent(new CustomEvent('odftrades:gohome'))} title="Back to home">
        <ODFLogo size="sidebar" />
      </div>
      <div style={{ height: 1, background: '#1e1e2e', margin: '0 4px 16px' }} />
      <nav style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {NAV.map(item => {
          const Icon = item.icon;
          const isActive = active === item.id;
          return (
            <button key={item.id}
              className={`nav-item${isActive ? ' active' : ''}`}
              onClick={() => handleNav(item.id)}
              style={{ width: '100%', textAlign: 'left', background: 'none', outline: 'none', fontFamily: "'IBM Plex Sans', sans-serif" }}>
              <Icon size={16} />
              <span style={{ flex: 1 }}>{item.label}</span>
              {isActive && <ChevronRight size={14} style={{ opacity: 0.5 }} />}
            </button>
          );
        })}
      </nav>
      <div style={{ padding: '14px 8px 0', borderTop: '1px solid #1e1e2e', fontSize: 10, color: '#55556a', fontFamily: "'DM Mono', monospace", lineHeight: 1.8 }}>
        <div>SEE SETUP.</div>
        <div>WAIT FOR CONFIRMATION.</div>
        <div style={{ color: '#00e5a0' }}>DEFINE RISK & GO.</div>
      </div>
    </>
  );

  return (
    <>
      <aside className="desktop-sidebar" style={{
        width: 220, minHeight: '100vh',
        background: '#111118', borderRight: '1px solid #1e1e2e',
        display: 'flex', flexDirection: 'column',
        padding: '28px 12px 24px', flexShrink: 0,
        position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 10,
      }}>
        {sidebarContent}
      </aside>

      {/* Mobile top bar */}
      <div className="mobile-topbar" style={{
        display: 'none', position: 'fixed', top: 0, left: 0, right: 0,
        height: 56, background: '#111118', borderBottom: '1px solid #1e1e2e',
        zIndex: 100, alignItems: 'center', padding: '0 16px',
        justifyContent: 'space-between'
      }}>
        <div style={{ cursor:'pointer' }} onClick={() => window.dispatchEvent(new CustomEvent('odftrades:gohome'))} title="Go to home page">
          <ODFLogo size="compact" />
        </div>
        <button onClick={() => setMobileOpen(o => !o)} style={{
          background: 'none', border: 'none', color: '#f0f0f5', cursor: 'pointer', padding: 4
        }}>
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {mobileOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 99, background: 'rgba(0,0,0,0.6)' }}
          onClick={() => setMobileOpen(false)}>
          <aside style={{
            width: 240, height: '100%',
            background: '#111118', borderRight: '1px solid #1e1e2e',
            display: 'flex', flexDirection: 'column',
            padding: '72px 12px 24px',
          }} onClick={e => e.stopPropagation()}>
            {sidebarContent}
          </aside>
        </div>
      )}
    </>
  );
}
